import Url from 'url-parse';
import { sendRequest } from '@alme/ui-web/ref/lib-alme-request';

// TODO: Remove this module in favor of DynamicUrl plugin (see AEX-323)

export default class ResponseUrlConverter {
    constructor(settings) {
        this._settings   = settings || {};
        this._urlTarget  = settings.navConstants.targetTypes.url;
        this._domainMaps = {};

        const hMaps  = (this._settings.UrlReplacer || {}).HostMaps || [];
        const hosts  = [].concat(...hMaps.map(m => m.hosts));
        const mapFor = (host) => {
            const dMaps = hMaps.filter(m => m.hosts.includes(host)).map(m => m.domainMap);
            return Object.assign({}, ...dMaps);
        };
        hosts.forEach(h => this._domainMaps[h] = mapFor(h));
    }

    initialize(store){
        this._store = store;
    }

    getReducer() { return state => state; }

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    getRenderer() { return () => { }; }

    doesHandle(message) { return !!message.response; }

    process(message) {
        if (!this.doesHandle(message)) { return message; }
        const proc     = this.processResponse.bind(this);
        const response = Array.isArray(message) ? message.map(proc) : proc(message);
        return Object.assign({}, message, { response });
    }

    processResponse(message) {
        const response = message.response;
        this.convertNavUrl(response);
        this.convertDisplayLinks(response);
        response?.responseActions?.forEach(action => {
            if (action.Name === "CallToActionButton" && action.ButtonDisplayText === "Live Chat") {
                
                if (message.messageType !== this._settings.messageConstants.getHistoryRequest) {
                    const input =
                    {
                        messageType: this._settings.messageConstants.reportingEventRequest,
                        eventName: "ReferralOffered",
                        eventValue: action?.parameters?.Type,
                        origin: this._settings.originConstants.internal,
                    };
                    sendRequest(input);
                }
            }
        });
        return response;
    }

    convertNavUrl(response) {
        const url = (response.navUrl || {}).UrlAddress;
        if (url) {
            response.navUrl.UrlAddress = this.convertUrlString(url);
        }
    }

    convertDisplayLinks(response) {
        const convert  = this.convertSingleDisplayLink.bind(this);
        const sections = (response.displayLinkCollection || {}).Sections || [];
        sections.map(s => (s.Links || []).map(convert));
    }

    convertSingleDisplayLink(link) {
        const url = (link.Metadata || {}).UrlAddress;
        if (url && link.TargetType && link.TargetType.toLowerCase() === this._urlTarget.toLowerCase()) {
            link.Metadata.UrlAddress = this.convertUrlString(url);
        }
    }

    convertUrlString(urlString) {
        const url  = new Url(urlString, window.location, true);
        const dMap = this._domainMaps[window.location.host] || {};
        const host = dMap[url.hostname] || '';
        if (host) {
            url.host = url.hostname = host;
        }
        return (host) ? url.toString() : urlString;
    }
}


// WEBPACK FOOTER //
// ./components/response-handlers/nextit-response-url-converter.js